import React from 'react'
import PropTypes from 'prop-types'

import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import MoreMenu from "./more-menu"

export default function ListHeaderMore(props) {

    const onMoveRight           = () => {props.module.columns.moveRight(props.column.fieldId)}
    const onMoveLeft            = () => {props.module.columns.moveLeft(props.column.fieldId)}
    const onResetColumnWidth    = () => {props.module.columns.resetWidth(props.column.fieldId)}
    const onRemoveColumn        = () => {props.module.columns.remove(props.column.fieldId)}

    return (
        <div className="header-right">
            <PopupMenuButton className      = {Classes("more-icon", "gd-ui-more", "ui5-ico-more s20 hover-action", props.classname)}
                             offset         = "0 -14"
                             menuComponent  = {MoreMenu}
                             menuParams     = {{
                                 onMoveRight        : !props.dragEnabled || props.isLast ? null : onMoveRight,
                                 onMoveLeft         : !props.dragEnabled || props.isFirst || !props.canMoveLeft ? null : onMoveLeft,
                                 onResetColumnWidth : props.canResize ? onResetColumnWidth : null,
                                 onRemoveColumn     : props.canRemove ? onRemoveColumn : null,
                             }}/>
        </div>
    )
}

ListHeaderMore.propTypes = {
    module      : PropTypes.object,
    column      : PropTypes.object,

    dragEnabled : PropTypes.bool,
    canRemove   : PropTypes.bool,
    canResize   : PropTypes.bool,
    canMoveLeft : PropTypes.bool,
    isFirst     : PropTypes.bool,
    isLast      : PropTypes.bool,
}
